import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ep_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const qrImage = (token) => `${API}/qr/${token}.png`;
export const errText = (e) => {
  const detail = e?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(", ");
  if (typeof detail === "string") return detail;
  return e?.message || "Something went wrong";
};

export default api;
